import { Component, Input } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
    selector: 'app-confirmation-dialog',
    templateUrl: './confirmation-dialog.component.html',
    styleUrls: ['./confirmation-dialog.component.scss'],
    standalone: false
})
export class ConfirmationDialogComponent {

  @Input() title: string = '';
  @Input() message: string = '';
  @Input() confirmButtonText: string = 'Confirmer';
  @Input() cancelButtonText: string = 'Annuler';
  @Input() confirmButtonStatus: 'basic' | 'primary' | 'success' | 'info' | 'warning' | 'danger' = 'primary';
  @Input() cancelButtonStatus: 'basic' | 'primary' | 'success' | 'info' | 'warning' | 'danger' = 'basic';
  @Input() icon: string = '';
  @Input() iconStatus: 'basic' | 'primary' | 'success' | 'info' | 'warning' | 'danger' = 'primary';

  constructor(
    protected dialogRef: NbDialogRef<ConfirmationDialogComponent>
  ) {}

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
